import { render, staticRenderFns } from "./FederateBirthDate.vue?vue&type=template&id=503e1d22&scoped=true&"
import script from "./FederateBirthDate.vue?vue&type=script&lang=js&"
export * from "./FederateBirthDate.vue?vue&type=script&lang=js&"
import style0 from "./FederateBirthDate.vue?vue&type=style&index=0&id=503e1d22&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e1d22",
  null
  
)

export default component.exports